import Footer from "components/footer/FooterAuthDefault";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";
import Video from "../../assets/img/auth/video.mp4";
import bgDot from "../../assets/img/auth/Dot.png";
import SignIn from "views/auth/SignIn";
import "./auth.css";

export default function Auth() {
  document.documentElement.dir = "ltr";
  return (
    <>
      <div className="bgContainer">
        <div className="overlay"></div>
        <div className="bgVideo-container">
          <video className="bgVideo" src={Video} autoPlay loop muted />
        </div>
        <div className="card-box">
          <div>
            <SignIn />
            <img src={bgDot} alt="" className="bgDot1" />
            <img src={bgDot} alt="" className="bgDot2" />
          </div>
        </div>
        <div className="foot flex">
          <Footer />
          <FixedPlugin />
        </div>
      </div>
    </>
  );
}
